import { Component, Inject, inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ActivatedRoute } from "@angular/router";
import {
  faCircleInfo,
  faStopwatch,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { GraphqlService } from "../../../../../services/graphql.service";
import { TableConfiguration } from "../../../../../shared/components/paginated-data-table/paginated-table-configuration.model";
import { GET_SENSOR_ALERT_DATA, UPDATE_SENSOR_ALERT_DATA } from "../../../../../store/entities/warehouse-management/sensor-alert/sensor-alert.graphql";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../store";
import { StoreItemActions } from "../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../store/entities/store-item/store-item.model";
import { Observable } from "rxjs";
import { SensorAlertFields } from "../../../../../store/entities/warehouse-management/sensor-alert/sensor-alert.model";
import { ActionButton } from "../../../../../common/interfaces/global-interfaces";
import { AlertCommentModalComponent } from "./alert-comment-modal/alert-comment-modal.component";

@Component({
  selector: "app-alerts-modal",
  templateUrl: "./alerts-modal.component.html",
  styleUrl: "./alerts-modal.component.scss",
})
export class AlertsModalComponent implements OnInit {
  private dialogRef: MatDialogRef<AlertsModalComponent> = inject(MatDialogRef<AlertsModalComponent>);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private apollo: GraphqlService = inject(GraphqlService);
  private store: Store<AppState> = inject(Store<AppState>);

  duration;
  query;
  filters;
  selectedTab = 0;
  alertCounts = [0, 0, 0, 0]; 
 warehouseUniqueId: string | null = null;


  

  
  alertTypeMap = [
    "MAX_HUMIDITY",     
    "MIN_HUMIDITY",     
    "MAX_TEMPERATURE", 
    "MIN_TEMPERATURE"   
  ];

  protected readonly faCircleInfo = faCircleInfo;
  protected readonly faStopwatch = faStopwatch;
  protected readonly faCircle = faCircle;

  title: string;

  tableConfiguration: TableConfiguration = {
    tableColumns: [
      { name: "warehouseName", label: "Warehouse Name" },
      { name: "sensorName", label: "Sensor" },
      { name: "alertType", label: "Alert Type" },
      { name: "reading", label: "Readings" },
      { name: "status", label: "Status" },
      { name: "createdAt", label: "Created Date" },
      { name: "updatedAt", label: "Updated Date" },
    ],
    showNumbers: true,
    showBorder: true,
    allowPagination: true,
    useRowClick: true,
    hideExport: true,
      useFullObject: true,   
    empty_msg: "No data found",
    actionIcons: {
      edit: false,
      delete: false,
      more: false,
      print: false,
      customPrimary: false,
    },
    deleting: {},
    active: {}
  };

  actionButtons: ActionButton[] = [
    {
      id: "edit",
      label: "Change Status",
      title: "Change Status",
      icon: "edit",
      action: "edit",
      confirm_first: true,
      confirm_message: "Confirm status update?",
    },
  ];

  permissions = {
    edit: ["can_edit_sensor_alerts"],
  };

  mapFunction = (item: any) => {
    const convert = (t) =>
      t === "MAX_HUMIDITY" ? "High Humidity" :
      t === "MIN_HUMIDITY" ? "Low Humidity" :
      t === "MAX_TEMPERATURE" ? "High Temperature" :
      t === "MIN_TEMPERATURE" ? "Low Temperature" :
      "Unknown";

    return { ...item, alertType: convert(item.alertType) };
  };

  constructor(@Inject(MAT_DIALOG_DATA) data,  private matDialog: MatDialog) {
    this.duration = data?.duration;
        this.warehouseUniqueId = data?.warehouseUniqueId || null;
        console.log("Warehouse Unique ID received in modal:", this.warehouseUniqueId); 
  }

  ngOnInit() {
    this.title = "Alerts";
    this.query = GET_SENSOR_ALERT_DATA;

    this.updateFilters();
  }

  onTabChange(tabIndex: number) {
    this.selectedTab = tabIndex;
    this.updateFilters();
  }

  updateFilters() {
    const alertType = this.alertTypeMap[this.selectedTab];
    this.filters = {
     warehouseUniqueId: this.warehouseUniqueId ?? this.route.snapshot.queryParams["id"] ?? null,
      duration: this.duration,
      alertType: alertType
    };
  }

onCustomAction(evt: any) {
  console.log("EVENT:", evt);

  if (evt?.action !== "edit") return; // 👈 IMPORTANT

  console.log("Row value:", evt.value);

  const alert = evt.value;
  const newStatus =
    alert.status === "RESOLVED" ? "UNRESOLVED" : "RESOLVED";

  const dialogRef = this.matDialog.open(AlertCommentModalComponent, {
    width: "400px",
    data: { alert, newStatus },
  });

  dialogRef.afterClosed().subscribe((comment: string) => {
    if (!comment) return;

    this.store.dispatch(
      StoreItemActions.createUpdateStoreItem({
        entity: StoreItemEntity.alertData,
        mutation: UPDATE_SENSOR_ALERT_DATA,
        input: {
          uniqueId: alert.uniqueId,
          status: newStatus,
          comments: comment,
        },
        isInput: true,
      })
    );
  });
}

  closeModal() {
    this.dialogRef.close();
  }
}
